import { Divider } from "antd";
import { images } from "../../assets";

const ProfileHeader = ({ user }: any) => {
  const isStaff = user?.roles?.includes("employee");
  return (
    <div
      style={{
        backgroundColor: "white",
        borderRadius: "16px",
        padding: "24px",
        marginBottom: "32px",
        display: "flex",
        alignItems: "center",
        gap: "24px",
        flexWrap: "wrap",
        position: "relative",
      }}
    >
      <img
        src={user.image || images.avatar}
        alt={user.name}
        style={{
          width: "120px",
          height: "120px",
          borderRadius: "12px",
          objectFit: "cover",
        }}
      />
      <div style={{ flex: 1 }}>
        <div
          style={{ fontSize: "14px", fontWeight: "600", marginBottom: "4px" }}
        >
          Y&apos;ello
        </div>
        <h1
          style={{ fontSize: "32px", fontWeight: "bold", marginBottom: "8px" }}
        >
          {user.name}
        </h1>
        <p style={{ color: "#666", marginBottom: "12px" }}>
          It's great seeing you again!
        </p>

        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "16px",
          }}
        >
          <div
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: user?.isActive ? "#4caf50" : "red",
            }}
          />
          <span style={{ fontWeight: "600" }}>
            {user?.isActive ? "Active" : "Inactive"}
          </span>
          <Divider type="vertical" size="large" />
          <span style={{ color: "#666" }}>
            {isStaff ? `Staff - ${user?.hcm?.jobLevel}` : "Third Party"}
          </span>
        </div>

        {/* <div>
        <CustomButton variant="primary">Express Interest →</CustomButton>
      </div> */}
      </div>
    </div>
  );
};

export default ProfileHeader;
